// skipcq: JS-W1028, JS-0128
import PropTypes from 'prop-types';
import {
  Card,
  CardContent,
  Typography,
  Chip,
  Stack,
} from '@mui/material';

import { CHECKIN_TYPE_BEER, CHECKIN_TYPE_BREWERY } from '../../utils/mapCheckinDoc';

/**
 * Formats a date to a readable string
 */
function formatDate(date) {
  if (!date) return 'Unknown Date';
  try {
    return new Date(date).toLocaleString();
  } catch {
    return 'Invalid Date';
  }
}

function BreweryLocationLine({ checkin }) {
  if (checkin.type !== CHECKIN_TYPE_BEER && checkin.type !== CHECKIN_TYPE_BREWERY) {
    return null;
  }

  const locationLabel = checkin.breweryLocationLabel;
  if (!locationLabel || locationLabel === checkin.primaryTitle) {
    return null;
  }

  return (
    <Typography variant="body2" color="text.secondary" gutterBottom>
      Brewery: {locationLabel}
    </Typography>
  );
}

BreweryLocationLine.propTypes = {
  checkin: PropTypes.shape({
    type: PropTypes.string,
    breweryLocationLabel: PropTypes.string,
    primaryTitle: PropTypes.string,
  }).isRequired,
};

/**
 * Displays a single enriched check-in for Engage admin.
 */
function CheckinCard({ checkin }) {
  return (
    <Card sx={{ width: '100%', maxWidth: 600, mb: 2 }}>
      <CardContent>
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
          <Chip label={checkin.typeLabel} size="small" color="primary" variant="outlined" />
        </Stack>
        <Typography variant="h6" component="div" gutterBottom>
          {checkin.primaryTitle}
        </Typography>
        <BreweryLocationLine checkin={checkin} />
        <Typography variant="body2" color="text.secondary" gutterBottom>
          User: {checkin.userName}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Date: {formatDate(checkin.date)}
        </Typography>
      </CardContent>
    </Card>
  );
}

CheckinCard.propTypes = {
  checkin: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    typeLabel: PropTypes.string,
    primaryTitle: PropTypes.string,
    beerName: PropTypes.string,
    breweryLocationLabel: PropTypes.string,
    userName: PropTypes.string,
    date: PropTypes.instanceOf(Date),
  }).isRequired,
};

export default CheckinCard;
